import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'building_guid': 'String',
	'floor_guid': 'String',
	'room_guid': 'String',
	'employee_guid': '[String]',
};

export default gql( `
	mutation employee_building_rights( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_building_rights( ${ HelperGraphql.createVariables( fields ) } ) {
	       updated_at
	    }
	}
` );

